import Badge from './ui/Badge';

// Stati in italiano: l'utente non deve leggere le costanti del backend.
const STATI = {
  ready: { testo: 'Connesso', tone: 'success' },
  authenticated: { testo: 'Autenticato', tone: 'info' },
  qr_pending: { testo: 'In attesa del QR', tone: 'warning' },
  initializing: { testo: 'Avvio in corso', tone: 'neutral' },
  disconnected: { testo: 'Disconnesso', tone: 'danger' },
  failed: { testo: 'Non riuscito', tone: 'danger' },
  success: { testo: 'Riuscito', tone: 'success' },
  pending: { testo: 'In attesa', tone: 'warning' },
  queued: { testo: 'In coda', tone: 'warning' },
  sending: { testo: 'Invio in corso', tone: 'info' },
  sent: { testo: 'Inviato', tone: 'info' },
  delivered: { testo: 'Consegnato', tone: 'success' },
  read: { testo: 'Letto', tone: 'success' },
  scheduled: { testo: 'Programmato', tone: 'info' },
  completed: { testo: 'Completato', tone: 'success' },
  stopped: { testo: 'Fermato dal destinatario', tone: 'neutral' },
  cancelled: { testo: 'Annullato', tone: 'neutral' },
  missed: { testo: 'Scaduto senza invio', tone: 'warning' },
  unknown: { testo: 'Esito incerto', tone: 'warning' },
  waiting: { testo: 'In consegna', tone: 'info' },
  succeeded: { testo: 'Completato', tone: 'success' },
};

export function etichettaStato(status) {
  return STATI[status]?.testo || status;
}

export default function StatusBadge({ status }) {
  const { testo, tone } = STATI[status] || { testo: status, tone: 'neutral' };
  return <Badge tone={tone}>{testo}</Badge>;
}
